<mat-toolbar class="mat-ctrlkey-midnight">
    <span tabindex="0" (keyup.enter)="navigate('/')" (click)="navigate('/')">
      <img class="brand-logo ps-1 pe-3" src="CtrlKey_White.png" alt="Keystone CrtlKey Branding">
      <img class="brand-logo" [src]="siteLogo" alt="">
    </span>

    <span class="d-none d-md-flex mx-auto username">
      {{ username }}
    </span>

    <!-- Tools -->
    <span class="ps-1">
      <a matFab extended class="narrow-button" routerLink="." [matMenuTriggerFor]="tools">
        Tools
        <mat-icon>construction</mat-icon>
      </a>
      <!-- Menu options -->
      <mat-menu #tools="matMenu" xPosition="before">
        <button mat-menu-item (click)="navigate('/tool/compare')">
          <mat-icon>difference</mat-icon>
          <span>XER Comparison</span>
        </button>

        <!-- <button mat-menu-item (click)="navigate('/tool/validator')">
          <mat-icon>check_circle</mat-icon>
          <span>XER Validator</span>
        </button> -->

        <!-- <button mat-menu-item (click)="navigate('/tool/weather')">
          <mat-icon>cloud</mat-icon>
          <span>Weather Predict</span>
        </button> -->
      </mat-menu>
    </span>

    <!-- Help & Support -->
    <span class="ps-1">
      <a matFab extended class="narrow-button" routerLink="." [matMenuTriggerFor]="support">
        Support
        <mat-icon>help</mat-icon>
      </a>
      <!-- Menu options -->
      <mat-menu #support="matMenu" xPosition="before">
        <button mat-menu-item (click)="navigate('/docs')">
          <mat-icon>book</mat-icon>
          <span>Application & Help Documentation</span>
        </button>

        <button mat-menu-item (click)="navigate('/changelog')">
          <mat-icon>published_with_changes</mat-icon>
          <span>Version Changelog</span>
        </button>

        <button mat-menu-item (click)="sendErrorReport()">
          <mat-icon>support</mat-icon>
          <span>Contact Developer</span>
        </button>
      </mat-menu>
    </span>

    <!-- User Account -->
    @if (loginDisplay) {
      <span class="ps-1">
        <a matFab extended class="narrow-button" routerLink="." [matMenuTriggerFor]="account">
          Account
          <mat-icon>account_circle</mat-icon>
        </a>
        <!-- Menu options -->
        <mat-menu #account="matMenu" xPosition="before">
          <button mat-menu-item (click)="openUserSettings()">
            <mat-icon>settings</mat-icon>
            <span>User Settings</span>
          </button>
        </mat-menu>
      </span>
    }

    <!-- Admin -->
    @if (isSiteAdmin) {
      <span class="ps-1">
        <a matFab extended class="narrow-button" routerLink="." [matMenuTriggerFor]="admin">
          Admin
          <mat-icon>shield</mat-icon>
        </a>
        <!-- Menu options -->
        <mat-menu #admin="matMenu" xPosition="before">
          <button mat-menu-item (click)="navigate('/admin')">
            <mat-icon>admin_panel_settings</mat-icon>
            <span>Site Administration</span>
          </button>

          <button mat-menu-item (click)="openUploadList()">
            <mat-icon>upload</mat-icon>
            <span>Active Project Uploads</span>
          </button>

          @if (isGlobalAdmin) {
            <button mat-menu-item (click)="exportUserAccess()">
              <mat-icon>access_alarm</mat-icon>
              <span>Export Latest User Access</span>
            </button>

            <button mat-menu-item (click)="exportProjectAccess()">
              <mat-icon>access_alarm</mat-icon>
              <span>Export Latest Project Access</span>
            </button>

            <button mat-menu-item (click)="navigate('/metrics')">
              <mat-icon>bar_chart</mat-icon>
              <span>Webserver Metrics</span>
            </button>
          }
        </mat-menu>
      </span>
    }

    <!-- Login -->
    <span class="ps-1">
      @if (!loginDisplay) {
        <button matFab extended class="narrow-button" (click)="authService.login()">
          Login
          <mat-icon>login</mat-icon>
        </button>
      } @else {
        <button matFab extended class="narrow-button" (click)="authService.logout()">
          Logout
          <mat-icon>logout</mat-icon>
        </button>
      }
    </span>
</mat-toolbar>
